import './Savings.scss';
import { formatToUKCurrency } from '../../../../../utils/formatToUKCurrency';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

export default function Savings({ fields, monthlyPhevSavings, yearlyPhevSavings }) {
  return (
    <div className={'card'} data-aos="fade-up">
      <p className={'card_text'}>{fields?.totalText?.value}</p>
      <p className={'card_price'}>{formatToUKCurrency(yearlyPhevSavings)}</p>
      <p className={'card_pricePerMonth'}>
        {formatToUKCurrency(monthlyPhevSavings)} {fields?.timeTitle?.value}
      </p>
      <div className={'card_image'}>
        <img src={fields?.carImage?.value?.src} alt="img" />
      </div>
      <div className={'card_title'}>
        <RichText field={fields?.carName} />
      </div>
    </div>
  );
}
